import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { baseQueryWithProvider } from "@/redux/baseQuery";
import { ExternalSuppliersFormOptions } from "@/redux/slices/externalSupplier/types";
import { createSearchParams } from "@/utils";
import { transformExternalSuppliers, transformExternalSuppliersFormOptions, transformExternalSupplierProfile } from "./helpers";
import {
  AddExternalSupplierParams,
  GetExternalSuppliersParams,
  GetExternalSuppliersResponse,
  GetExternalSupplierProfileResponse,
  UpdateExternalSupplierParams,
} from "./types";

export const externalSupplierApi = createApi({
  reducerPath: "externalSupplierApi",
  baseQuery: baseQueryWithProvider("external-supplier"),
  endpoints: (builder) => ({
    getExternalSuppliers: builder.query<GetExternalSuppliersResponse, GetExternalSuppliersParams>({
      query: (params) => `?${createSearchParams(params).toString()}`,
      providesTags: ["ExternalSuppliers"],
      transformResponse: transformExternalSuppliers,
    }),
    getExternalSupplierProfile: builder.query<GetExternalSupplierProfileResponse, string>({
      query: (id) => `/${id}`,
      providesTags: ["ExternalSupplierProfile"],
      transformResponse: transformExternalSupplierProfile,
    }),
    getExternalSuppliersFormOptions: builder.query<ExternalSuppliersFormOptions, void>({
      query: () => "/options",
      transformResponse: transformExternalSuppliersFormOptions,
    }),
    addExternalSupplier: builder.mutation<void, AddExternalSupplierParams>({
      query: (body) => ({
        url: "",
        method: "POST",
        body,
      }),
      invalidatesTags: ["ExternalSuppliers"],
    }),
    updateExternalSupplier: builder.mutation<void, UpdateExternalSupplierParams>({
      query: ({ id, ...body }) => ({
        url: `/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["ExternalSupplierProfile"],
    }),
  }),
  tagTypes: ["ExternalSuppliers", "ExternalSupplierProfile"],
});

export const {
  useGetExternalSuppliersQuery,
  useGetExternalSupplierProfileQuery,
  useGetExternalSuppliersFormOptionsQuery,
  useAddExternalSupplierMutation,
  useUpdateExternalSupplierMutation,
} = externalSupplierApi;
